module.exports = __webpack_public_path__ + "static/media/base_registration_background.d77a95c6.png";